export default __webpack_public_path__ + "static/media/caret-downn.a76d6bce.png";